import React, { useState, useEffect,useContext } from 'react';
import { axios } from '../services/ServiceUtils';
import LanguageContext from "./LanguageContext";

const AboutDFSContext = React.createContext();
const { Provider, Consumer } = AboutDFSContext;

const AboutDFSProvider = props => {
  const [aboutDFS, setaboutDFS] = useState({
    imageUrl: '',
    title: '',
    description: '',
    error: false,
    errorStatus: false
  });

  const {language} = useContext(LanguageContext);
  const { children } = props;
  const aboutDFSError = status => {
    setaboutDFS({ title: '', imageUrl: '', description: '', error: true, errorStatus: status });
  };

  useEffect(() => {
    axios.get('api/about-dfs',{
        headers:{
          'Content-Language': `${language.locale}`
        }
      })
      .then(result => {
        if (!result.data.description) {
          aboutDFSError(200);
        } else {
          setaboutDFS({
            imageUrl: result.data.imageUrl,
            title: result.data.title,
            description: result.data.description,
            error: false,
            errorStatus: false,
          });
        }
      })
      .catch(e => {
        aboutDFSError(e.response.status);
        // eslint-disable-next-line
        console.error('request error', e.response.status);
      });
  }, [language]);

  return <Provider value={aboutDFS}>{children}</Provider>;
}

export { AboutDFSProvider, Consumer as ConsumerProvider };
export default AboutDFSContext;
